import React from 'react';

const AddonSetTitle = ({ record }) => {
	return <span>AddonSet {record ? `"${record.name}"` : ''}</span>;
};

export default AddonSetTitle;
